/**
 * Filter Offcanvas Handler
 * Automatically closes the offcanvas after filter submission
 */

export default function initFilterOffcanvas() {
  // Get all filter forms in offcanvas
  const offcanvasForms = document.querySelectorAll('.offcanvas form[id*="filter"]');

  if (offcanvasForms.length === 0) return;

  offcanvasForms.forEach(form => {
    // Handle form submission
    form.addEventListener('submit', (e) => {
      const offcanvasElement = form.closest('.offcanvas');
      if (offcanvasElement) {
        // Close offcanvas after a short delay (allow form submission)
        setTimeout(() => {
          const bsOffcanvas = bootstrap.Offcanvas.getInstance(offcanvasElement);
          if (bsOffcanvas) {
            bsOffcanvas.hide();
          }
        }, 100);
      }
    });

    // Handle auto-submit selects (for year/category filters)
    const autoSubmitSelects = form.querySelectorAll('select[onchange*="submit"]');
    autoSubmitSelects.forEach(select => {
      select.addEventListener('change', () => {
        const offcanvasElement = form.closest('.offcanvas');
        if (offcanvasElement) {
          setTimeout(() => {
            const bsOffcanvas = bootstrap.Offcanvas.getInstance(offcanvasElement);
            if (bsOffcanvas) {
              bsOffcanvas.hide();
            }
          }, 150);
        }
      });
    });
  });
}
